import { render, staticRenderFns } from "./ViewCamera3.vue?vue&type=template&id=18f0cf68&scoped=true&"
import script from "./ViewCamera3.vue?vue&type=script&lang=js&"
export * from "./ViewCamera3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f0cf68",
  null
  
)

export default component.exports